import React from 'react';
import '../css/OkasBoxes.css';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import OkasBoxesView from './OkasBoxesView';
import OkasBoxesEdit from './OkasBoxesEdit';
import OkasBoxesAddNew from './OkasBoxesAddNew';
import OkasAssignDistributors from './OkasAssignDistributors';
import Sorting from './Sorting';
// import SearchBar from 'material-ui-search-bar';
import SearchBar from './SearchBar';
// import SearchBarNew from './SearchBar'; 
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
import { OverlayTrigger, Overlay } from 'react-bootstrap'
import { calculator } from 'react-icons-kit/ionicons';
// import { Hidden, TablePagination } from '@material-ui/core';
import edit from './../assets/images/edit.svg';
import view from './../assets/images/view.svg';
import deleteIcon from './../assets/images/delete.svg';
import Pagination from 'react-bootstrap/Pagination';
import Tooltip from '@mui/material/Tooltip';


import Loader from './Loader';

//okasboxes dashboard page
const customStylesDelete = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    minHeight: '40%',
    overflow: 'auto',
    padding: '2%',
    backgroundColor: '#EFF3F6'
  }
};

const styles = theme => ({
  root: {
    display: 'flex',
    // flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: 120,
    width: '100%',
    border: 'none'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
    width: '100%',
  },
});



class OkasBoxes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpenAddOB: false,
      modalIsOpenAddOBDistributors: false, // Distributors Added
      modalIsOpenAddOBView: false,
      modalIsOpenAddOBEdit: false,
      modalIsOpenDeleteSuccess: false,
      noOfParams: [],
      obData: [],

      siData: [],
      actualData: [],
      searchValue: '',
      loader: true,
      assinedBoxesDB: 0,
      assinedBoxesSI: 0,
      assinedBoxesProjects: 0,
      unAssinedBoxes: 0,
      someState: setTimeout(() => {
        if (this.props.redux.auth.searchBarShow) {
          return 'true'
        } else {
          return 'false'
        }
      }, 500),
      sortingStatus: {
        sortingName: '',
        defaultDown: true
      },
      //states for pagination in table
      paginationTable: {
        currentPage: 0,
        pageNeighbours: 2,
        recordPerPage: 10,
        totalRecords: 0,
        recordFirstID: 0,
        recordLastID: 0,
        buttonArray: []
      }

    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeDistributorsModal = this.closeDistributorsModal.bind(this); // Distributors Added
    this.closeModalDelete = this.closeModalDelete.bind(this);
    this.openDistributorsModal = this.openDistributorsModal.bind(this); // Distributors Added
  }

  openModal() {
    this.setState({
      modalIsOpenAddOB: false

    }, () => {
      this.setState({
        modalIsOpenAddOB: true

      })
    })
  }

  openDistributorsModal() {
    this.setState({
      // modalIsOpenAddOB: false,
      modalIsOpenAddOBDistributors: false
    }, () => {
      this.setState({
        // modalIsOpenAddOB: true,
        modalIsOpenAddOBDistributors: true
      })
    })
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({ modalIsOpenAddOB: false });

  }
  closeDistributorsModal() { // Distributor added

    this.setState({ OkasAssignDistributors: false });
  }

  closeModalDelete() {
    this.setState({
      modalIsOpenDelete: false
    });
  }


  ActivateOBModel = (e) => {
    if (this.state.modalIsOpenAddOB) {
      return <OkasBoxesAddNew activeModal={true} refreshDevices={this.refreshDevices.bind(this)} />
    } else {
      return null
    }
  }

  ActivateOBModelDistributors = (e) => { // Distributors added
    if (this.state.modalIsOpenAddOBDistributors) {
      return <OkasAssignDistributors activeModal={true} refreshDevices={this.refreshDevices.bind(this)} />
    } else {
      return null
    }
  }

  refreshDevices = (e) => {
    this.setState({
      modalIsOpenAddOB: false,
      modalIsOpenAddOBDistributors: false, // Distributors Added
      modalIsOpenAddOBView: false,
      modalIsOpenAddOBEdit: false,
      modalIsOpenDeleteSuccess: false,
    }, () => {
      this.fetchDevices();
    })
  }

  //function for pagination

  paginationFunction = () => {
    // debugger
    // console.log('asd')
    let totalButton = (this.state.obData.length / this.state.paginationTable.recordPerPage);
    let emtyArray = Array.apply(null, { length: Math.ceil(totalButton) }).map(Number.call, Number)

    // let emtyArray = new Array(Math.ceil(totalButton)).fill('0');
    this.setState({
      paginationTable: {
        ...this.state.paginationTable,
        buttonArray: emtyArray
      }
    })
  }

  ActivateObModelView = (e) => {
    if (this.state.modalIsOpenAddOBView) {
      return <OkasBoxesView activeModal={true} ObCurrentData={this.state.ObCurrentData} refreshDevices={this.refreshDevices.bind(this)} />
    } else {
      return null
    }
  }

  ActivateObModelEdit = (e) => {
    if (this.state.modalIsOpenAddOBEdit) {
      return <OkasBoxesEdit activeModal={true} ObCurrentData={this.state.ObCurrentData} refreshDevices={this.refreshDevices.bind(this)} />
    } else {
      return null
    }
  }

  componentDidMount() {
    this.fetchSI()
    // this.fetchDevices();
    this.resetSearchBar()

    // if (this.state.modalIsOpenDeleteSuccess) {
    //   this.closeModalTimeout = setTimeout(() => {
    //     this.setState({
    //       modalIsOpenDeleteSuccess: false,
    //     });
    //   }, 5000); // 5000 milliseconds (5 seconds) delay
    // }
  }

  // componentWillUnmount() {
  //   // Clear the timeout when the component is about to unmount
  //   clearTimeout(this.closeModalTimeout);
  // }
  onDeleteFinal = (e) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }

    fetch(`/cloud/okasBoxApi_Detail/${this.state.itemToDeleteId}`, {
      method: "DELETE",
      headers: headers,
      body: JSON.stringify({ hello: "hello" })
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.fetchDevices();
        this.setState({
          modalIsOpenDelete: false,
          modalIsOpenDeleteSuccess: true
        })
      })
      .catch((err) => {
        console.log(err)

      })
  }

  fetchDevices = () => {
    this.setState({
      loader: true
    })
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/okasBoxApi/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        let obData = data;
        // console.log(data)
        data.forEach((obElement) => {
          if (obElement.okasBox_status === 'unassigned') {
            this.setState({
              unAssinedBoxes: this.state.unAssinedBoxes + 1
            })
          }
          if (obElement.okasBox_status === 'Assigned Distributor') {
            this.setState({
              assinedBoxesDB: this.state.assinedBoxesDB + 1
            })
          }
          if (obElement.okasBox_status === 'Assigned SI') {
            this.setState({
              assinedBoxesSI: this.state.assinedBoxesSI + 1
            })
          }
          // Project Manager
          if (obElement.okasBox_status === 'Assigned Project') {
            this.setState({
              assinedBoxesProjects: this.state.assinedBoxesProjects + 1

            })
          }
        })
        this.setState({
          obData: obData,
          actualData: obData,
          loader: false
        }, () => {
          this.paginationFunction();
        })
        // console.log(this.state.obData)
      })
      .catch((err) => {
        console.log(err)
      })
  }


  restoreData = (data) => {
    this.setState({
      obData: data
    })
  }

  sortingFunc = (type, searchValue) => {
    if (type !== 'search') {
      if (this.state.sortingStatus.sortingName === type) {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: !this.state.sortingStatus.defaultDown
          },
        }, () => {



          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.obData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.obData.sort());
          }
        })
      } else {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: true
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.obData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.obData.sort());
          }
        })
      }
    } else if (type === 'search') {
      type = 'search';
      Sorting(this.restoreData, type, this.state.actualData, searchValue);
    } else {
      type = 'reverse';
      Sorting(this.restoreData, type, this.state.actualData);
    }
  }

  assignedBoxRender = (status) => {
    if (status === 'unassigned') {
      return <div style={{ height: '2.5vh', width: '3vw', marginLeft: '19px', backgroundColor: '#A9A9A9', borderRadius: "2.5vh", }}></div>
    } else if (status === 'Assigned Distributor') {
      return <div style={{ height: '2.5vh', width: '3vw', marginLeft: '19px', backgroundColor: '#00B0A9', borderRadius: "2.5vh", }}></div>
    } else if (status === "Assigned SI") {
      return <div style={{ height: '2.5vh', width: '3vw', marginLeft: '19px', backgroundColor: '#F07E25', borderRadius: "2.5vh", }}></div>
    }
    else if (status === "Assigned Project") {
      return <div style={{ height: '2.5vh', width: '3vw', marginLeft: '19px', backgroundColor: '#76ab58', borderRadius: "2.5vh", }}></div>
    }
  }

  fetchSI = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/si_IntegratorApi/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.setState({
          siData: data,
        }, () => {
          this.fetchDevices()
        })
      })

  }

  fetchIconType = (e) => {

    if (e === this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-down pointer ml-2 float-right'
    } else if (e === this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-up pointer ml-2 float-right'
    } else {
      return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
    }
  }

  obDatatable = () => {

    if (this.state.obData !== null) {
      let someData = this.state.obData.map((obElement, index) => {
        const dateFromString = new Date(obElement.created_at);
        const dateOnly = dateFromString.toISOString().split('T')[0];
        return <tr key={index} className="some-hover">
          <td scope="col" style={{ width: '50px', fontSize: '12px' }} >{index + 1}</td>
          <td scope="col" style={{ width: '80px', fontSize: '12px' }}>
            {obElement.okasBox_type === 'Master Controller' ? 'Master Studio' :
              obElement.okasBox_type === "VOD Box" ? "Media Studio" :
                obElement.okasBox_type === "UVOD Box" ? "Ultra Media Studio" :
                  obElement.okasBox_type === "Audio Box" ? "Music Studio" : obElement.okasBox_type}</td>
          <td scope="col" style={{ width: '20%', fontSize: '12px' }}>{obElement.user}</td>
          <td scope="col" style={{ width: '100px', fontSize: '12px' }}>{obElement.okasBox_serialNo}</td>
          <td scope="col" style={{ width: '100px', fontSize: '12px' }}>{obElement.okasBox_version}</td>
          <td scope="col" style={{ width: '70px', fontSize: '12px' }}>{dateOnly}</td>
          <td scope="col" style={{ width: '80px', paddingLeft: '10px', fontSize: '12px' }}>{this.assignedBoxRender(obElement.okasBox_status)}</td>
          <td style={{ width: '150px', textAlign: 'center' }}>
            <span
              onClick={
                (e) => {
                  if (this.state.modalIsOpenAddOBView) {
                    this.setState({ modalIsOpenAddOBView: false }, () => {
                      this.setState({
                        modalIsOpenAddOBView: true,
                        ObCurrentData: obElement,

                      })
                    })
                  } else {
                    this.setState({
                      modalIsOpenAddOBView: true,
                      ObCurrentData: obElement
                    })
                  }
                }}>
              <img src={view} alt="" style={{ width: '16px', height: '16px', marginRight: '15px' }} />
            </span>


            <Tooltip
              title={obElement.okasBox_status !== 'unassigned' ? 'Assigned' : ''}
              arrow
              disableHoverListener={obElement.okasBox_status === 'unassigned'}
            >
              <span style={{ display: 'inline-block' }}>
                <span
                  style={{
                    pointerEvents: obElement.okasBox_status !== 'unassigned' ? 'none' : 'auto',
                    opacity: obElement.okasBox_status !== 'unassigned' ? 0.5 : 1,
                    cursor: obElement.okasBox_status !== 'unassigned' ? 'not-allowed' : 'pointer',
                  }}
                  onClick={(e) => {
                    if (obElement.okasBox_status === 'unassigned') {
                      if (this.state.modalIsOpenAddOBEdit) {
                        this.setState({ modalIsOpenAddOBEdit: false }, () => {
                          this.setState({
                            modalIsOpenAddOBEdit: true,
                            ObCurrentData: obElement,
                          });
                        });
                      } else {
                        this.setState({
                          modalIsOpenAddOBEdit: true,
                          ObCurrentData: obElement,
                        });
                      }
                    }
                  }}
                >
                  <img
                    src={edit}
                    alt=""
                    style={{ width: '16px', height: '16px', marginRight: '15px' }}
                  />
                </span>
              </span>
            </Tooltip>


            <Tooltip
              title={obElement.okasBox_status !== 'unassigned' ? 'Assigned' : ''}
              arrow
              disableHoverListener={obElement.okasBox_status === 'unassigned'}
            >
              <span style={{ display: 'inline-block' }}>
                <span
                  style={{
                    pointerEvents: obElement.okasBox_status !== 'unassigned' ? 'none' : 'auto',
                    opacity: obElement.okasBox_status !== 'unassigned' ? 0.5 : 1,
                    cursor: obElement.okasBox_status !== 'unassigned' ? 'not-allowed' : 'pointer',
                  }}
                  onClick={() => {
                    if (obElement.okasBox_status === 'unassigned') {
                      this.setState({
                        itemToDeleteId: obElement.okasBox_id,
                        modalIsOpenDelete: true,
                      });
                    }
                  }}
                >
                  <img
                    src={deleteIcon}
                    alt=""
                    style={{ width: '16px', height: '16px', marginRight: '15px' }}
                  />
                </span>
              </span>
            </Tooltip>

          </td>
        </tr>
      })
      return someData;
    } else {
      return null
    }
  }
  numberOfBoxes = (boxState) => {
    let numberOfBoxType = 0;
    this.state.actualData.forEach((e) => {
      if (e.okasBox_status === boxState) {
        numberOfBoxType = numberOfBoxType + 1;
      }
    })
    return numberOfBoxType
  }

  siNameHandler = (data, siId) => {
    let siName = 'Unassigned';
    data.forEach((element) => {
      if (Number(element.si_id) === Number(siId)) {
        siName = element.si_userName
      }
    })
    return siName
  }


  overlayShadowUnderModal = (type) => {
    if (type === 'overlay') {
      if (this.state.modalIsOpenAddOB || this.state.modalIsOpenAddOBView || this.state.modalIsOpenAddOBEdit || this.state.modalIsOpenDeleteSuccess) {
        return (
          <div style={{ position: 'absolute', height: `${window.innerHeight - 60}px`, width: `${window.innerWidth - 260}px`, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: '0', display: '' }}></div>
        )
      } else {
        return null
      }
    } else if (type === 'scroll') {
      return 'hidden'
    }
    // Distributors Added
    if (type === 'overlay') {
      if (this.state.modalIsOpenAddOBDistributors || this.state.modalIsOpenAddOBView || this.state.modalIsOpenAddOBEdit || this.state.modalIsOpenDeleteSuccess) {
        return (
          <div style={{ position: 'absolute', height: `${window.innerHeight - 60}px`, width: `${window.innerWidth - 260}px`, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: '0', display: '' }}></div>
        )
      } else {
        return null
      }
    } else if (type === 'scroll') {
      return 'hidden'
    }
  }


  resetSearchBar = () => {
    this.props.searchBarActivate(false)
  }


  render() {
    return (
      <React.Fragment>
        {this.state.loader ? <Loader /> : null}
        {this.overlayShadowUnderModal('overlay')}
        <div style={{ paddingLeft: '5px', paddingTop: '40px', paddingRight: '20px', height: `${window.innerHeight - 70}px` }}>
          {!this.props.redux.auth.searchBarShow ? <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#888888', fontSize: '30px', }}>OKAS INVENTORY</span>
            <span style={{ float: 'right' }}>
              {!this.props.redux.auth.searchBarShow ? <div className="row" style={{ margin: '0' }}>
                {/* Add new Additional inventory request start*/}
                {/* <a
                  //  href='/OkasAdditionalInventoryRequest'
                  href='#'
                >
                  <div className="pointer" >
                    <div className="buttonContent" style={{ backgroundColor: '#2976a7', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)', marginRight: '5px' }}>
                      <span style={{ color: '#FFFFFF', fontSize: '10px', fontWeight: '600', paddingLeft: '6px' }}>ADDITIONAL INVENTORY REQUEST</span>
                    </div>
                  </div>
                </a> */}
                {/* Add new Additional inventory request end*/}

                {/* Add new ASSIGNEE DISTRIBUTOR start*/}
                <div className="pointer"  >   {/* onClick={this.openDistributorsModal} <-- need to added this code after className='pointer'  */}

                  <a href='/okasboxes/assignboxes' style={{textDecoration:'none'}}> <div className="buttonContent" style={{ backgroundColor: '#00B0A9', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)', marginRight: '5px' }}>
                    {/* <Icon icon={iosPlusEmpty} size={40} style={{ color: "#FFFFFF", backgroundColor: "none", }} /> */}
                    <IconButton sx={{
                      color: '#fff',
                      fontSize: 40,
                      backgroundColor: 'transparent',
                      '&:hover': {
                        backgroundColor: 'transparent'
                      },
                      '&:focus': {
                        outline: 'none',
                        border: 'none',
                        backgroundColor: 'transparent'
                      }
                    }} aria-label="add">
                      <AddIcon sx={{ fontSize: 40 }} />
                    </IconButton>

                    <span style={{ color: '#FFFFFF', fontSize: '10px', fontWeight: '600' }}>ASSIGNEE DISTRIBUTOR</span>
                  </div> </a>
                </div>
                {/* Add new ASSIGNEE DISTRIBUTOR end*/}
                {/* Add new OKAS Boxes start*/}
                <div className="pointer" onClick={this.openModal} >
                  <div className="buttonContent" style={{ backgroundColor: 'white', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)' }}>
                    {/* <Icon icon={iosPlusEmpty} size={40} style={{ color: "#F08100", backgroundColor: "none", }} /> */}
                    <IconButton sx={{
                      color: '#F08100',
                      fontSize: 40,
                      backgroundColor: 'transparent',
                      '&:hover': {
                        backgroundColor: 'transparent'
                      },
                      '&:focus': {
                        outline: 'none',
                        border: 'none',
                        backgroundColor: 'transparent'
                      }
                    }} aria-label="add">
                      <AddIcon sx={{ fontSize: 40 }} />
                    </IconButton>
                    <span style={{ color: '#888888', fontSize: '10px', fontWeight: '600' }}>ADD NEW OKAS BOX</span>
                  </div>

                </div>
                {/* Add new OKAS Boxes end*/}
              </div> : null}
            </span>
          </div> : <div className='animated animated-duration-custom slideInDown pb-3 mt-2 flex-fill'>
            <SearchBar
              value={this.state.searchValue}
              onChange={(e) => {
                this.setState({
                  searchValue: e
                }, () => {
                  this.sortingFunc('search', this.state.searchValue)
                })
              }
              }
              onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
              resetSearch={(e) => {
                this.setState({
                  searchValue: e
                }, () => {
                  this.sortingFunc('search', '')
                })
              }}
            />
          </div>}
          {!this.props.redux.auth.searchBarShow ? <div class="d-flex">
            <div class="flex-fill" style={{ marginRight: '50px' }}>
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#A9A9A9', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Unassigned<br />OKAS Inventory</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '10px', marginTop: '10px', float: 'right', borderRadius: "15px 15px 0px 0px" }} >{this.numberOfBoxes('unassigned')}</div>
                </div>
              </div>
            </div>
            <div class="flex-fill" style={{ marginRight: '50px' }}>
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#00b0a9', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Assigned to<br />Distributor</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '10px', marginTop: '10px', float: 'right', }} >{this.numberOfBoxes('Assigned Distributor')}</div>
                </div>
              </div>
            </div>
            <div class="flex-fill" style={{ marginRight: '50px' }}>
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#76ab58', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Assigned to<br />Project Manager</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '10px', marginTop: '10px', float: 'right', }} >{this.numberOfBoxes('Assigned Project')}</div>
                </div>
              </div>
            </div>
            <div class="flex-fill">
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#F07E25', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Assigned to<br />System Integrator</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '10px', marginTop: '10px', float: 'right', }} >{this.numberOfBoxes('Assigned SI')}</div>
                </div>
              </div>
            </div>

          </div> : null}
          <table className="table" style={{ marginTop: '30px' }}>
            <thead className="tableHeader" style={{ borderRadius: '10px 10px 0px 0px', backgroundColor: '#a9a9a9', color: '#eff3f7' }}> {/* tableHeaderColor */}

              <th scope="col" style={{ width: '60px', fontSize: '12px' }} >
                S.NO
                <i class={this.fetchIconType('okasBox_id')} onClick={(e) => { this.sortingFunc('okasBox_id') }}>
                </i>
              </th>
              <th scope="col" style={{ width: '80px', fontSize: '12px' }}>
                TYPE
                <i class={this.fetchIconType('okasBox_type')} onClick={(e) => { this.sortingFunc('okasBox_type') }}></i>
              </th>
              <th scope="col" style={{ width: '20%', fontSize: '12px' }}>
                ASSIGNEE EMAIL
                <i class={this.fetchIconType('user')} onClick={(e) => { this.sortingFunc('user') }}></i>
              </th>
              <th scope="col" style={{ width: '100px', fontSize: '12px' }}>
                SERIAL NO
                <i class={this.fetchIconType('okasBox_serialNo')} onClick={(e) => { this.sortingFunc('okasBox_serialNo') }}></i>
              </th>
              <th scope="col" style={{ width: '100px', fontSize: '12px' }}>
                VERSION
                <i class={this.fetchIconType('okasBox_version')} onClick={(e) => { this.sortingFunc('okasBox_version') }}></i>
              </th>
              <th scope="col" style={{ width: '80px', fontSize: '12px' }}>
                DATE
                <i class={this.fetchIconType('okasBox_version')} onClick={(e) => { this.sortingFunc('okasBox_version') }}></i>
              </th>
              <th scope="col" style={{ width: '80px', fontSize: '12px' }}>
                STATUS
                {/* <i class={this.fetchIconType('okasBox_status')} onClick={(e) => { this.sortingFunc('okasBox_status') }}></i> */}
              </th>
              <th scope="col" style={{ width: '150px', fontSize: '12px' }}>
                VIEW | EDIT | DELETE
              </th>
            </thead>
            <tbody style={{ maxHeight: this.props.redux.auth.searchBarShow ? `${window.innerHeight - 200}px` : `${window.innerHeight - 370}px`, overflowY: 'overlay' }}>
              {this.obDatatable()}
            </tbody>
          </table>

        </div>
        {this.ActivateOBModel()}
        {this.ActivateOBModelDistributors()} {/* Distributors Added */}
        {this.ActivateObModelView()}
        {this.ActivateObModelEdit()}
        <Modal
          isOpen={this.state.modalIsOpenDelete}
          style={customStylesDelete}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModalDelete}>
              <i className="fas fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Are you sure you want to proceed with deletion?</h3>
            <i class="fas  fa-question-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5" onClick={this.onDeleteFinal.bind(this)}>Delete </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.modalIsOpenDeleteSuccess}
          style={customStylesDelete}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times"
              onClick={() => {
                this.setState({
                  modalIsOpenDeleteSuccess: false
                })

              }}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">OKAS Box deleted successfully.</h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            {/* <div className="btn reset-btn mx-2 px-5"
             onClick={() => {
              this.setState({
                modalIsOpenDeleteSuccess: false
              })
        
            }}></div> */}
          </div>

          {/* Add setTimeout to close the modal after a specified time (e.g., 20000 milliseconds) */}
          {setTimeout(() => {
            this.setState({
              modalIsOpenDeleteSuccess: false
            });
          }, 10000)}
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    redux: state,
  };
};


const mapDispatchToProps = dispatch => {
  return {
    searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
    searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),

  };
};


export default connect(mapStateToProps, mapDispatchToProps)(OkasBoxes);